import { render, staticRenderFns } from "./CardsetDetail.vue?vue&type=template&id=ca53f986&scoped=true&"
import script from "./CardsetDetail.vue?vue&type=script&lang=js&"
export * from "./CardsetDetail.vue?vue&type=script&lang=js&"
import style0 from "./CardsetDetail.vue?vue&type=style&index=0&id=ca53f986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca53f986",
  null
  
)

export default component.exports